/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import React from "react"
import { SectionGrid } from "frontend/src/components/Layout"
import { CMSLink } from "frontend/src/components/CMSLink"
import { useLocation } from "frontend/src/utils/useLocation"

function CtaHeaderDesktop({ backgroundDesktop, companyLogo, titleParts, buttonText }) {
  return (
    <SectionGrid sx={{ width: "100%", display: ["none", "none", "block"] }}>
      <div
        sx={{
          display: ["none", "none", "grid"],
          width: "100vw",
          gridColumn: "1 / span 5",
          gridRow: "1 / span 1",
          gridTemplateColumns: "1fr minmax(20px,200px) minmax(600px,900px) minmax(20px,200px) 1fr",
          height: "41.8vw",
          backgroundImage: `url(${backgroundDesktop})`,
          backgroundRepeat: "repeat",
          backgroundColor: "rgb(35, 41, 66)",
          backgroundPosition: "54% 33%",
          backgroundSize: "cover",
        }}
      >
        <div
          sx={{
            gridColumn: "3 / span 1",
            gridRow: "1 / span 1",
            display: ["none", "none", "grid"],
            gridTemplateColumns: ["1fr", "1fr", "1fr 1fr"],
            zIndex: 2,
          }}
        >
          <div
            sx={{
              gridColumn: "1 / span 1",
              gridRow: "1 / span 1",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <img
              src={companyLogo}
              alt="sleep.ink logo"
              sx={{
                width: ["unset", "unset", "17.45625vw", "210px"],
                height: ["unset", "unset", "3.82375vw", "46px"],
                mt: ["unset", "unset", "1vw", "15px"],
                mb: ["unset", "unset", "7vw", "60px"],
              }}
            />
            <h2
              sx={{
                variant: "text.h3",
                fontFamily: "body",
                fontSize: ["10.898vw", "43.592px", "3.623585vw", "43.592px"],
                lineHeight: ["13.25vw", "53px", "4.405625vw", "53px"],
                fontWeight: 700,
                zIndex: 2,
                mt: ["unset", "unset", "2.5vw", "60px"],
                mb: ["unset", "unset", "7.5vw", "30px"],
              }}
            >
              {titleParts &&
                titleParts.map((part, index) => {
                  const { text, color, linebreakAfterDesktop } = part
                  return (
                    <React.Fragment>
                      <span sx={{ color: color }}>{text}</span>
                      {linebreakAfterDesktop && <br />}
                    </React.Fragment>
                  )
                })}
            </h2>
            <CMSLink
              link={{
                externalUrl: "#angebot",
                newtab: false,
                follow: false,
                event: "anchorClick",
                destination: "offerSection",
                pageType: "LandingPage",
                section: "header",
              }}
              sx={{
                backgroundColor: "almostBlack",
                color: "background",
                border: "none",
                borderRadius: "41px",
                outline: "none",
                width: ["68.75vw", "275px", "22.859375vw", "275px"],
                height: ["12.5vw", "50px", "4.15625vw", "50px"],
                lineHeight: ["12.5vw", "50px", "4.15625vw", "50px"],
                fontWeight: 700,
                fontFamily: "body",
                fontSize: ["6.192vw", "24.768px", "2.05884vw", "24.768px"],
                zIndex: 2,
                textAlign: "center",
                "&:active": {
                  outline: "none",
                },
              }}
            >
              {buttonText}
            </CMSLink>
          </div>
        </div>
      </div>
    </SectionGrid>
  )
}

function CtaHeaderMobile({ companyLogo, titleParts, buttonText, backgroundMobile }) {
  return (
    <SectionGrid
      sx={{
        width: "100%",
        display: ["block", "block", "none"],
      }}
    >
      <div
        sx={{
          backgroundImage: `url(${backgroundMobile})`,
          backgroundRepeat: "repeat",
          backgroundColor: "rgb(35, 41, 66)",
          backgroundPosition: "54% 23%",
          backgroundSize: "cover",
          width: "100vw",
          height: "40,475rem",
          minHeight: "600px",
          maxHeight: "650px",
          textAlign: "center",
        }}
      >
        <div sx={{ width: ["90vw", "360px", "29.925vw", "360px"], margin: "0 auto" }}>
          <img
            src={companyLogo}
            alt="sleep.ink logo"
            sx={{
              width: ["52.25vw", "209px", "17.373125vw", "209px"],
              height: ["11.5vw", "46px", "3.82375vw", "46px"],
              marginY: 5,
            }}
          />
          <h2
            sx={{
              variant: "text.h3",
              fontFamily: "body",
              fontSize: ["7.9256vw", "31.7024px", "2.635262vw", "31.7024px"],
              lineHeight: ["11.25vw", "45px", "3.740625vw", "45px"],
              fontWeight: 700,
              my: ["8vw", "30px", "unset", "unset"],
              mb: ["90vw", "380px", "20px", "30px"],
            }}
          >
            {titleParts &&
              titleParts.map((part, index) => {
                const { text, color, linebreakAfterMobile } = part
                return (
                  <React.Fragment>
                    <span key={index} sx={{ color: color }}>
                      {text}
                    </span>
                    {linebreakAfterMobile && <br />}
                  </React.Fragment>
                )
              })}
          </h2>
          <CMSLink
            link={{
              externalUrl: "#angebot",
              newtab: false,
              follow: false,
              event: "anchorClick",
              destination: "offerSection",
              pageType: "LandingPage",
              section: "header",
            }}
            sx={{
              display: "inline-block",
              backgroundColor: "almostBlack",
              color: "background",
              border: "none",
              borderRadius: "41px",
              outline: "none",
              width: ["64vw", "256px", "21.28vw", "256px"],
              height: ["10.25vw", "41px", "3.408125vw", "41px"],
              lineHeight: ["10.25vw", "41px", "3.408125vw", "41px"],
              fontWeight: 700,
              fontFamily: "body",
              fontSize: "1.548rem",
              zIndex: 2,
              textAlign: "center",
              "&:active": {
                outline: "none",
              },
            }}
          >
            {buttonText}
          </CMSLink>
        </div>
      </div>
    </SectionGrid>
  )
}

function PressLogosDesktop({ pressLogos }) {
  const { pathname } = useLocation()
  return (
    <SectionGrid
      sx={{ backgroundColor: "rgb(45, 45, 45)", display: ["none", "none", "grid"], py: 5 }}
    >
      <div
        sx={{
          gridColumn: "3 / span 1",
          color: "white",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <p
          sx={{
            textTransform: "uppercase",
            fontFamily: "body",
            fontWeight: 500,
            fontSize: ["4.4584vw", "17.8336px", "1.482418vw", "17.8336px"],
            lineHeight: ["7.25vw", "29px", "2.410625vw", "29px"],
            py: 4,
          }}
        >
          {pathname.includes("offer") ? "Known from:" : "Bekannt aus:"}
        </p>
        {pressLogos &&
          pressLogos.map((logo, index) => {
            const { title, url } = logo
            return (
              <img
                key={index}
                src={url}
                alt={title}
                sx={{ height: ["8.25vw", "33px", "2.743125vw", "33px"] }}
              />
            )
          })}
      </div>
    </SectionGrid>
  )
}

function PressLogosMobile({ pressLogos }) {
  const logos = pressLogos.filter(logo => logo.showMobile)
  const { pathname } = useLocation()
  return (
    <SectionGrid
      sx={{ backgroundColor: "rgb(45, 45, 45)", display: ["block", "block", "none"], py: 3 }}
    >
      <div
        sx={{
          color: "white",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <p
          sx={{
            textTransform: "uppercase",
            fontFamily: "body",
            fontWeight: 500,
            fontSize: ["2.972vw", "11.888px", "0.98819vw", "11.888px"],
            lineHeight: ["4.25vw", "17px", "1.413125vw", "17px"],
            mb: 3,
          }}
        >
          {pathname.includes("offer") ? "Known from:" : "Bekannt aus:"}
        </p>
      </div>
      <div
        sx={{
          color: "white",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        {logos &&
          logos.map((logo, index) => {
            const { title, url } = logo
            return <img key={index} src={url} alt={title} sx={{ height: "21px" }} />
          })}
      </div>
    </SectionGrid>
  )
}

function CtaHeader({
  titleParts,
  companyLogo,
  buttonText,
  backgroundDesktop,
  backgroundMobile,
  pressLogos,
}) {
  return (
    <React.Fragment>
      <CtaHeaderDesktop
        titleParts={titleParts}
        companyLogo={companyLogo}
        buttonText={buttonText}
        backgroundDesktop={backgroundDesktop}
        sx={{ desktop: ["none", "none", "block"] }}
      />
      <CtaHeaderMobile
        companyLogo={companyLogo}
        titleParts={titleParts}
        buttonText={buttonText}
        backgroundMobile={backgroundMobile}
        sx={{ display: ["block", "block", "none"] }}
      />
      <PressLogosDesktop pressLogos={pressLogos} sx={{ display: ["none", "none", "block"] }} />
      <PressLogosMobile pressLogos={pressLogos} sx={{ display: ["block", "block", "none"] }} />
    </React.Fragment>
  )
}

export { CtaHeader }
